import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import about from '@/components/about'
import tutorial from '@/components/tutorial'
import login from '@/components/login'
import personal from '@/components/personal'
import contact from '@/components/contact'
import underreview from '@/components/underreview'
import document from '@/components/document'
import Insurance from '@/components/Insurance'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    }, {
      path: '/about',
      name: 'about',
      component: about
    }, {
      path: '/tutorial',
      name: 'tutorial',
      component: tutorial
    }, {
      path: '/login',
      name: 'login',
      component: login
    }, {
      path: '/personal',
      name: 'personal',
      component: personal
    }, {
      path: '/contact',
      name: 'contact',
      component: contact
    }, {
      path: '/underreview',
      name: 'underreview',
      component: underreview
    }, {
      path: '/document',
      name: 'document',
      component: document
    }, {
      path: '/Insurance',
      name: 'Insurance',
      component: Insurance
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js